export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign']
